import { Directive } from '@angular/core';

@Directive({ selector: '[sbbIcon]' })
export class SbbIconDirective {}
